import { computed, readonly, ref } from "vue";

const headerHeight = ref(0);
const visibleHeaderHeight = ref(0);
const isHidden = ref(false);
let isManualVisibleHeightControlEnabled = false;

const setCSSVariable = (variable: string, value: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.style.setProperty(variable, value);
  }
};

const syncCSSVariables = () => {
  setCSSVariable("--vf-header-height", `${headerHeight.value}px`);
  setCSSVariable(
    "--vf-header-visible-height",
    `${visibleHeaderHeight.value}px`
  );
};

const updateVisibleHeaderHeight = (height: number) => {
  visibleHeaderHeight.value = Math.max(0, height);
  syncCSSVariables();
};

const updateHeaderHeight = (height: number) => {
  headerHeight.value = Math.max(0, height);
  if (!isHidden.value && !isManualVisibleHeightControlEnabled) {
    updateVisibleHeaderHeight(headerHeight.value);
  }
};

const updateHeaderHidden = (hidden: boolean) => {
  isHidden.value = hidden;
  if (!isManualVisibleHeightControlEnabled) {
    updateVisibleHeaderHeight(hidden ? 0 : headerHeight.value);
  }
};

const setVisibleHeaderHeight = (height: number) => {
  updateVisibleHeaderHeight(height);
};

const enableManualVisibleHeaderHeightControl = () => {
  isManualVisibleHeightControlEnabled = true;

  return () => {
    isManualVisibleHeightControlEnabled = false;
    updateVisibleHeaderHeight(isHidden.value ? 0 : headerHeight.value);
  };
};

const useHeaderHeight = () => {
  return {
    headerHeight: readonly(headerHeight),
    visibleHeaderHeight: readonly(visibleHeaderHeight),
    isHeaderHidden: computed(() => isHidden.value),
    setHeaderHeight: updateHeaderHeight,
    setHeaderHidden: updateHeaderHidden,
    setVisibleHeaderHeight,
    enableManualVisibleHeaderHeightControl,
  };
};

export default useHeaderHeight;
